import { Backdrop, CircularProgress } from '@material-ui/core';
import Error from '@material-ui/icons/Error';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import MvmApi from '../../../services/MvmApi';
import nfe from './images/nfe.png';
import truck from './images/truck.png';
import { useStyles } from './Style';

type props =  any;

interface iShedData {
    shedCode: string;
    shedDescription: string;
    pendingInvoices: string;
    pendingMvms: string;
    overtimeInvoices: string;
    overtimeMvms: string;
    finishedInvoices: string;
    finishedMvms: string;
} 

const MvmMonitorSheds: React.FC<props> = ({ plantId }) => {
    const classes = useStyles();
    const [lista, setLista] = useState<iShedData[]>([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(true);
    const { t } = useTranslation("MvmMonitor");

    const { isLoading, isFetching, data, refetch } = useQuery('monitorMvmSheds_'+plantId, async () => {
        return await MvmApi.getMonitorSheds(plantId);
    } ,{
        refetchOnWindowFocus: false,
        staleTime: 1000 * 30, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 30, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        if (data)
            setLista(data);
    }, [data])

    useEffect(() => {
        setOpenBackdrop(isFetching);
    }, [isFetching])

    useEffect(() => {refetch();}, [plantId]);

    return (
        <div style={{display: 'flex', flexDirection: 'column', padding: 4}}>

                <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <table className={classes.table} cellSpacing={0} cellPadding={0}>
                    <tr>
                        <th style={{textAlign: 'center', border: 'solid 1px'}}>
                            {t('title_Shed')}
                        </th>
                        <th colSpan={2} style={{textAlign: 'center', border: 'solid 1px'}}>
                            {t('title_PendingBilling')}
                            <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                <img src={truck} alt='truck' width={30} height={30}/>
                                <img src={nfe} alt='nfe' width={30} height={30}/>
                            </div>
                        </th>
                        <th colSpan={2} style={{textAlign: 'center', border: 'solid 1px'}}>
                            {t('title_Overtime')}
                            <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                <img src={truck} alt='truck' width={30} height={30}/>
                                <Error color="error"/>
                                <img src={nfe} alt='nfe' width={30} height={30}/>
                            </div>
                        </th>
                        <th colSpan={2} style={{textAlign: 'center', border: 'solid 1px'}}>
                            {t('title_Finished')}
                            <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                <img src={truck} alt='truck' width={30} height={30}/>
                                <img src={nfe} alt='nfe' width={30} height={30}/>
                            </div>
                        </th>
                    </tr>
                    {lista.map((reg: iShedData) => (
                        <tr key={reg.shedCode}>
                            <td style={{ border: 'solid 1px #000', padding: 4}}>
                                {reg.shedCode === '' ? reg.shedDescription : (reg.shedCode + ' - ' + reg.shedDescription) }
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.pendingMvms}
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.pendingInvoices}
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.overtimeMvms}
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.overtimeInvoices}
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.finishedMvms}
                            </td>
                            <td  style={{width: 140, textAlign: 'center', border: 'solid 1px #000', padding: 4}}>
                                {reg.finishedInvoices}
                            </td>
                        </tr>
                    ))}
                </table>
                <br />
                {t('lastUpdate')}: {new Date().toLocaleString()}

        </div>
    )
}
export default MvmMonitorSheds;
